export enum PlatformEnum {
	IOS = 'IOS',
	ANDROID = 'ANDROID',
	DESKTOP = 'DESKTOP'
}

export type PlatformKeys = keyof typeof PlatformEnum;
